import { css } from "@emotion/react"
import styled from "@emotion/styled"

const dynamicStyle = ({ theme, colorVariant }) => css`
  background-color: ${colorVariant === "White"
    ? theme.palette.common.white
    : theme.palette.gray[50]};
`

const TechOneWrapper = styled.section`
  ${({ theme }) => theme.breakpoints.down("xl")} {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    padding-top: 90px;
    padding-bottom: 90px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    padding-top: 120px;
    padding-bottom: 120px;
  }

  ${dynamicStyle}
`
export default TechOneWrapper
